import { Button, Flex, Text } from "@gravity-ui/uikit";
import { useNavigate } from "react-router-dom";
import { RoutesPaths } from "src/routes/RoutesPaths";

export const DontHaveSubscribeBlock = () => {
  const navigate = useNavigate();

  return (
    <Flex width={"100%"} alignItems={"center"} direction={"column"} gap={6}>
      <Flex direction={"column"} alignItems={"center"} gap={2}>
        <Text variant="subheader-3" color="warning-heavy">
          Уважаемый пользователь
        </Text>
        <Text
          variant="subheader-1"
          style={{ textAlign: "center", maxWidth: 400 }}
        >
          Для продолжения использования всех преимуществ нашего сервиса, мы
          рекомендуем оформить подписку.
        </Text>
      </Flex>

      <Button
        view="action"
        size="l"
        onClick={() => navigate(RoutesPaths.LK.SUBSCRIBE)}
      >
        Приобрести подписку
      </Button>
    </Flex>
  );
};
